module.exports = __webpack_public_path__ + "static/media/heroImage.25d90b23.svg";